import { DateTime } from "luxon";
import * as t from "io-ts";
const isoDateTimeForJSON = new t.Type("isoDateTime", DateTime.isDateTime, (i, ctx) => {
    if (typeof i !== "string") {
        return t.failure(i, ctx, "Not a date string" + i);
    }
    try {
        return t.success(DateTime.fromISO(i, { setZone: true }));
    }
    catch (e) {
        return t.failure(i, ctx, "Parsing date failed: " + e.message);
    }
}, (v) => {
    if (v.isValid) {
        return v.toISO();
    }
    throw new Error("Cannot encode an invalid DateTime");
});
export default isoDateTimeForJSON;
//# sourceMappingURL=isoDateTimeForJSON.js.map